<template>
  <div
    class="bb-select-users__wrapper"
    @click.stop
    :style="positionStyle"
    @mouseleave="onClose"
  >
    <VuePerfectScrollbar
      class="bb-select-users"
      v-click-outside="onClose"
      tabindex="0"
      :settings="scrollSettings"
    >
      <div class="bb-select-users__margin bb-select-users__margin_top"/>
      <div class="bb-select-users-user"
           @click.stop="setUser(user)"
           v-for="user in usersList"
           :key="user.id">
        <img
          v-if="user.image"
          class="bb-select-users-user__image"
          :src="getUserImage(user)"
        />
        <i class="icon-user bb-select-users-user__image" v-else/>
        <span class="bb-select-users-user__username">{{user.username}}</span>
      </div>
      <div class="bb-select-users__margin bb-select-users__margin_bottom"/>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get} from 'lodash'

export default {
  name: 'BBSelectUsers',
  props: {
    usersList: {
      type: Array,
      default: () => ([])
    },
    positionStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    scrollSettings: { wheelPropagation: false, minScrollbarLength: 25 }
  }),
  components: {
    VuePerfectScrollbar
  },
  methods: {
    getUserImage (user) {
      return get(user, 'image.path', '')
    },
    setUser (user) {
      this.$emit('setUser', user)
    },
    onClose () {
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-select-users {
  overflow: hidden;
  max-height: 194px;
  padding: 0 8px;

  &__wrapper {
    position: absolute;
    top: 34px;
    left: 1px;
    width: auto;
    min-width: 170px;
    background-color: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    z-index: 10;

    &:before {
      content: '';
      position: absolute;
      left: 8px;
      top: -5px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 5px 5px;
      border-color: transparent transparent $color-white transparent;
    }
  }

  &__margin {
    position: sticky;
    background-color: $color-white;
    height: 10px;
    width: 100%;
    z-index: 2;

    &_top {
      top: 0;
    }

    &_bottom {
      bottom: 0
    }
  }

  &-user {
    display: grid;
    grid-template-columns: 28px auto;
    grid-gap: 8px;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 16px;
    text-transform: capitalize;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      color: $color-accent;
    }

    &__image {
      width: 28px;
      height: 28px;
      color: $color-accent;
      object-fit: cover;
      font-size: 28px;
      border-radius: 50%;

      &:before {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBAddUserSelect/BBSelectUsers/BBSelectUsers.vue